"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Button_1 = __importDefault(require("../Button"));
var Transition_1 = __importDefault(require("../Transition"));
var UpdateBanner_less_1 = __importDefault(require("./UpdateBanner.less"));
var UpdateBanner = function (_a) {
    var className = _a.className, visible = _a.visible, label = _a.label, actionLabel = _a.actionLabel, closeLabel = _a.closeLabel, onAction = _a.onAction, onClose = _a.onClose;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Transition_1.default, { when: visible, name: 'slide-up' },
            react_1.default.createElement("div", { className: UpdateBanner_less_1.default['update-banner'], role: 'status' },
                react_1.default.createElement("div", { className: UpdateBanner_less_1.default['label'] }, label),
                react_1.default.createElement(Button_1.default, { className: UpdateBanner_less_1.default['button'], onClick: onAction }, actionLabel),
                react_1.default.createElement(Button_1.default, { className: UpdateBanner_less_1.default['close'], title: closeLabel, onClick: onClose },
                    react_1.default.createElement(react_2.default, { className: UpdateBanner_less_1.default['icon'], name: 'close' }))))));
};
exports.default = UpdateBanner;
